import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import { useEffect, useState } from "react"
import { Position } from "reactflow"

import { useAuthorizedAxiosClient } from "../../../../../../common/axios"
import CustomHandle from "../../CustomHandle"
import { getEditorData } from "../../utils"
import BaseNode, { GreenNodeLabel, NodeContentLayout } from "../BaseNode"
import EmailEditor from "./Editor"

export default function EmailNode(node) {
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [emailCampaign, setEmailCampaign] = useState({})
  const { loadCampaign } = useLoadEmailCampaign()
  const nodeCampaign = getEditorData(node)

  function handleNodeClicked() {
    setEditDialogOpen(true)
  }

  useEffect(
    () => {
      if (!nodeCampaign) {
        return
      }
      if (nodeCampaign.name) {
        setEmailCampaign(nodeCampaign)
      } else {
        loadCampaign(nodeCampaign.id, (campaignData) =>
          setEmailCampaign(campaignData)
        )
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nodeCampaign?.id]
  )

  return (
    <>
      <BaseNode node={node} rootProps={{ onClick: handleNodeClicked }}>
        <CustomHandle
          id="top-handle"
          type="target"
          position={Position.Top}
          node={node}
        />
        <GreenNodeLabel label="Action" />
        <NodeContentLayout
          title="Email"
          subtitle={emailCampaign.name || "No campaign selected"}
          Icon={EmailOutlinedIcon}
        ></NodeContentLayout>
        <CustomHandle
          id="bottom-handle"
          type="source"
          position={Position.Bottom}
          node={node}
        />
      </BaseNode>
      <EmailEditor
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        node={node}
      />
    </>
  )
}

function useLoadEmailCampaign() {
  const [isLoading, setIsLoading] = useState(false)
  const axios = useAuthorizedAxiosClient()

  function loadCampaign(campaignID, dataCallback) {
    setIsLoading(true)
    axios
      .get(`/workflows/api/email/${campaignID}/`)
      .then(({ data }) => {
        dataCallback(data)
      })
      .finally(() => setIsLoading(false))
  }

  return {
    isLoading,
    loadCampaign,
  }
}
